module.exports = __webpack_public_path__ + "static/media/quickstart-step-4.06b1c3ce.jpg";